import { ReactNode, useCallback, useState } from 'react';

import {
  Service,
  ServiceContext,
  ServiceFeatureConfigurations,
  initialServiceValues,
} from 'contexts/serviceContext';

export default function ServiceProvider({ children }: { children: ReactNode }) {
  const [service, setService] = useState<Service>(initialServiceValues);
  const [isLoading, setIsLoading] = useState(true);

  const updateConfigurations = useCallback(
    (configurations: Partial<ServiceFeatureConfigurations>) => {
      setService((prev) => ({
        ...prev,
        configurations: { ...prev.configurations, ...configurations },
      }));
    },
    []
  );

  return (
    <ServiceContext.Provider
      value={{
        ...service,
        setService,
        updateConfigurations,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </ServiceContext.Provider>
  );
}
